import "./Listing";
import "./Show";
import "./ShowEmpty";
import "./ShowEmptyEmpForDate";
import "select2";
import WorkDayEmbedForm from "./modals/WorkDayEmbedForm";
import WorkDayModalForm from "./modals/WorkDayModalForm";
import MexportModalForm from "./modals/MexportModalForm";
import MassWorkDaysModalForm from "./modals/MassWorkDaysModalForm";
import WorkDaysHistoryModal from "./modals/WorkDaysHistoryModal";
import GridColumnsForm from "./modals/GridColumnsForm";

import AttendanceCalendar from "./show/AttendanceCalendar";
import AttendanceStatistics from "./show/AttendanceStatistics";
import Deposits from "./show/Deposits";
import ExtraShifts from "./show/ExtraShifts";
import PersonalBonuses from "./show/PersonalBonuses";
import VariableWages from "./show/VariableWages";
import Holidays from "./show/Holidays";
import Balances from "./show/Balances";
import DynamicAddition from "./show/DynamicAddition";

Vue.component('work-day-embed-form', WorkDayEmbedForm);
Vue.component('work-day-modal-form', WorkDayModalForm);
Vue.component('mexport-modal-form', MexportModalForm);
Vue.component('mass-work-days-modal-form', MassWorkDaysModalForm);
Vue.component('work-days-history-modal', WorkDaysHistoryModal);
Vue.component('attendance-calendar', AttendanceCalendar);
Vue.component('attendance-statistics', AttendanceStatistics);
Vue.component('deposits', Deposits);
Vue.component('extra-shifts', ExtraShifts);
Vue.component('personal-bonuses', PersonalBonuses);
Vue.component('variable-wages', VariableWages);
Vue.component('holidays', Holidays);
Vue.component('balances', Balances);
Vue.component('dynamic-addition', DynamicAddition);
Vue.component('attendance-grid-columns-form', GridColumnsForm);



// WEBPACK FOOTER //
// ./resources/assets/admin/js/attendance/index.js